import React from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { connect, useDispatch } from 'react-redux';
import { StyledTitle } from '../../components/StyledComponents';
import { setIsOpenPremiumModal } from '../../redux/mainReducer';

import { LetsGoBtn } from '../../components/Buttons';
import './DeleteModal.css';
import { base } from '../../redux/thunk';
import ApiService from '../../helpers/apiHelper';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 1200,
  width: { xs: '100%', sm: '90%', md: 'max-content' },
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function PremiumChooseModal({
  isOpenModal,
  premiumSubscription,
  getPremiumSubscriptionThunk,
  iframe
}) {
  const dispatch = useDispatch();
  const api = new ApiService('auth/change-premium-plan');
  const chooseFunc = (type) => {
    api.postDataQuery({ subscriptionType: type }).then((res) => {
      const iframe = document.getElementById('accSettingsPage');
      if (iframe) {
        iframe?.contentWindow.postMessage(
          'REFRESH SUBSCRIPTION',

          '*'
        );
      }
      dispatch(setIsOpenPremiumModal(false));
      getPremiumSubscriptionThunk();
    });
  };

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenPremiumModal(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenPremiumModal(false));
            }}
          />

          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ display: 'flex', flexDirection: 'column', alignContent: 'center' }}
            >
              <StyledTitle sx={{ marginBottom: '20px !important' }} className="bottomBlock-title">
                {'Тарифні плани'}
              </StyledTitle>
              <Typography
                variant="p"
                sx={{
                  fontFamily: 'FixelText-Medium !important',
                  fontWeight: '500',
                  color: '#7c7c7c',
                  fontSize: '18px',
                  textAlign: 'center !important'
                }}
              >
                Більше можливостей, більше зручності
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 4,
                flexWrap: 'wrap',
                gap: { xs: '24px', sm: '20px' }
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: '245px',
                  minWidth: '295px',
                  padding: '24px 20px',
                  border: 'none',
                  backgroundColor:
                    premiumSubscription?.subscriptionType &&
                    premiumSubscription?.subscriptionType === 'MONTH_PREMIUM'
                      ? '#F3F8FC'
                      : 'white',
                  borderRadius: '5px',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '28px',
                    textAlign: 'center !important'
                  }}
                >
                  Преміум “Місяць”
                </Typography>
                <Typography
                  variant="subtitle"
                  sx={{
                    margin: '10px 0px',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '26px',
                    textAlign: 'center'
                  }}
                >
                  {'780 грн '}

                  <span style={{ fontSize: '18px', fontWeight: '500' }}>(пдв 130 грн)</span>
                </Typography>
                {premiumSubscription?.nextSubscriptionType !== 'MONTH_PREMIUM' &&
                premiumSubscription?.subscriptionType !== 'MONTH_PREMIUM' ? (
                  <LetsGoBtn
                    colorScheme="blue"
                    className="service-card-btn"
                    width="100%"
                    margin="auto 0px 0px 0px"
                    text="Обрати"
                    onClick={() => {
                      chooseFunc('MONTH_PREMIUM');
                    }}
                  />
                ) : (
                  <Typography
                    variant="p"
                    sx={{
                      fontFamily: 'FixelText-Regular !important',
                      fontSize: '18px',
                      color: '#60A5DF'
                    }}
                  >
                    Ваш план
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: '245px',
                  minWidth: '295px',
                  margin: '0px',
                  padding: '24px 10px',
                  border: 'none',
                  backgroundColor:
                    premiumSubscription?.subscriptionType &&
                    premiumSubscription?.subscriptionType === 'THREE_MONTH_PREMIUM'
                      ? '#F3F8FC'
                      : 'white',
                  borderRadius: '5px',
                  position: 'relative',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Medium !important',
                    fontWeight: '500',
                    fontSize: '12px',
                    position: 'absolute',
                    backgroundColor: '#94D086',
                    p: '7px 20px',
                    top: '-15px',
                    borderRadius: '8px',
                    left: 'calc(100% / 2 - 50px)',
                    color: 'white'
                  }}
                >
                  {'Знижка 5%'}
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '28px',
                    textAlign: 'center !important'
                  }}
                >
                  Преміум “3 місяці”
                </Typography>
                <Typography
                  variant="subtitle"
                  sx={{
                    margin: '10px 0px 0px 0px',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '26px',
                    textAlign: 'center',
                    color: 'black'
                  }}
                >
                  {'2223 грн '}
                  <span style={{ fontSize: '18px', fontWeight: '500' }}>(пдв 370.5 грн)</span>
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Medium !important',
                    fontSize: '20px',
                    fontWeight: '500',
                    textAlign: 'center',
                    color: '#7c7c7c'
                  }}
                >
                  741 грн / міс
                </Typography>
                {premiumSubscription?.nextSubscriptionType !== 'THREE_MONTH_PREMIUM' &&
                premiumSubscription?.subscriptionType !== 'THREE_MONTH_PREMIUM' ? (
                  <LetsGoBtn
                    className="service-card-btn"
                    width="100%"
                    margin="auto 0px 0px 0px"
                    text="Обрати"
                    onClick={() => {
                      chooseFunc('THREE_MONTH_PREMIUM');
                    }}
                  />
                ) : (
                  <Typography
                    variant="p"
                    sx={{
                      fontFamily: 'FixelText-Regular !important',
                      fontSize: '18px',
                      color: '#60A5DF'
                    }}
                  >
                    Ваш план
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: '245px',
                  minWidth: '295px',
                  padding: '24px 20px',
                  border: 'none',
                  backgroundColor:
                    premiumSubscription?.subscriptionType &&
                    premiumSubscription?.subscriptionType === 'YEAR_PREMIUM'
                      ? '#F3F8FC'
                      : 'white',
                  borderRadius: '5px',
                  position: 'relative',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Medium !important',
                    fontWeight: '500',
                    fontSize: '12px',
                    color: 'white',
                    position: 'absolute',
                    backgroundColor: '#94D086',
                    p: '7px 20px',
                    top: '-15px',
                    borderRadius: '8px',
                    left: 'calc(100% / 2 - 50px)'
                  }}
                >
                  {'Знижка 7%'}
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '28px',
                    textAlign: 'center !important'
                  }}
                >
                  Преміум “Рік”
                </Typography>
                <Typography
                  variant="subtitle"
                  sx={{
                    margin: '10px 0px 0px 0px',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '26px',
                    textAlign: 'center'
                  }}
                >
                  {'8704.8 грн '}
                  <span style={{ fontSize: '18px', fontWeight: '500' }}>(пдв 1450.8 грн)</span>
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Medium !important',
                    fontSize: '20px',
                    fontWeight: '500',
                    textAlign: 'center',
                    color: '#7c7c7c'
                  }}
                >
                  725.4/міс
                </Typography>
                {premiumSubscription?.nextSubscriptionType !== 'YEAR_PREMIUM' &&
                premiumSubscription?.subscriptionType !== 'YEAR_PREMIUM' ? (
                  <LetsGoBtn
                    className="service-card-btn"
                    width="100%"
                    margin="auto 0px 0px 0px"
                    text="Обрати"
                    onClick={() => {
                      chooseFunc('YEAR_PREMIUM');
                    }}
                  />
                ) : (
                  <Typography
                    variant="p"
                    sx={{
                      fontFamily: 'FixelText-Regular !important',
                      fontSize: '18px',
                      color: '#60A5DF'
                    }}
                  >
                    Обрано
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    premiumSubscription: state.global.premiumSubscription
  };
};
export default connect(mapStateToProps, {
  getPremiumSubscriptionThunk: base.getPremiumSubscriptionThunk
})(PremiumChooseModal);
